import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import {
  assertEngineEarsErrorType,
  displayEngineEarsError,
} from "../../helpers";
import { updateReleaseTrack, UpdateReleaseTrackArgs } from "../releaseAPI";
import { convertStringToCommaSeparated } from "../../../utils/utils";

const useUpdateReleaseTrack = (releaseTrackId = 0) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.UPDATE_RELEASE_TRACK, releaseTrackId],
    mutationFn: async (args: UpdateReleaseTrackArgs) => {
      const formattedArgs = {
        ...args,
        ...(args.featured_artists && {
          featured_artists: convertStringToCommaSeparated(
            args.featured_artists,
          ),
        }),
      };
      return await updateReleaseTrack(releaseTrackId, formattedArgs);
    },
    onSuccess: (releaseTrack) => {
      toast.success("Release track updated successfully");
      void queryClient.invalidateQueries({
        queryKey: [
          QUERY_KEYS.FETCH_ARTIST_RELEASE_TRACKS,
          releaseTrack.release.id,
        ],
      });
    },
    onError: (error) => {
      if (assertEngineEarsErrorType(error)) {
        displayEngineEarsError(error);
      }
    },
  });
};

export default useUpdateReleaseTrack;
